import React from "react";
import { Heart, MessageCircle } from "lucide-react";

export const InfluencePostCard = ({ 
  id, 
  image, 
  caption, 
  date, 
  likes, 
  comments 
}) => {
  const formatCount = (count) => {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1) + 'M';
    }
    if (count >= 1000) {
      return (count / 1000).toFixed(1) + 'K';
    }
    return count?.toString() || '0';
  };

  return (
    <div className="group bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 overflow-hidden flex flex-col h-full">
      <div className="relative overflow-hidden aspect-square">
        <img
          src={image}
          alt="Post"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      <div className="flex flex-col flex-1 p-4">
        <div className="flex-1 mb-4">
          <p className="text-sm text-gray-700 line-clamp-3 min-h-[60px]">
            {caption || "No caption available"}
          </p>
        </div>

        <div className="mb-4">
          <p className="text-xs text-gray-500">
            {new Date(date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            })}
          </p>
        </div>

        <div className="flex justify-between items-center pt-3 border-t border-gray-100 mt-auto">
          <div className="flex items-center space-x-1">
            <Heart className="w-4 h-4 text-red-500" />
            <span className="text-sm font-medium text-gray-700">
              {formatCount(likes)}
            </span>
          </div>
          <div className="flex items-center space-x-1">
            <MessageCircle className="w-4 h-4 text-blue-500" />
            <span className="text-sm font-medium text-gray-700">
              {formatCount(comments)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};